// @flow

import { useMemo } from 'react';
import { type UserInputValidationError, useUserInputValidationError } from '@tectonics/prs/validation';
import { useFormHasBeenSent } from '@tectonics/prs/form-status';
import { useSubmitting } from '@tectonics/prs/submitting';
import { useMustShow } from '@tectonics/hooks';

type FieldInfo = {
  mustShow: boolean,
  submitting: boolean,
  formHasBeenSent: boolean,
  validationError: ?UserInputValidationError,
}

export function useFieldMetadata(fieldName: string): FieldInfo {
  const submitting = useSubmitting();
  const formHasBeenSent = useFormHasBeenSent();
  const validationError = useUserInputValidationError(fieldName);
  const mustShow = useMustShow(fieldName);

  return useMemo(() => ({
    mustShow,
    submitting,
    formHasBeenSent,
    validationError,
  }), [mustShow, submitting, formHasBeenSent, validationError]);
}
